/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiSignupAuthResponseFromJSON(json) {
    return ApiSignupAuthResponseFromJSONTyped(json, false);
}
export function ApiSignupAuthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'envs': !exists(json, 'envs') ? undefined : json['envs'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}
export function ApiSignupAuthResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'envs': value.envs,
        'refreshToken': value.refreshToken,
        'token': value.token,
    };
}
